import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import urlParse from 'url-parse';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import SocialMediaSharing from '@client/components/socialMediaSharing/SocialMediaSharing';
import {
  loadDonationPageData,
  selectDonatePageDonation,
} from '@client/pages/donatePage/duckDonatePage';
import MoreFromHlf from '@client/containers/moreFromHlf/MoreFromHlf';
import SimpleListing from '@client/components/listings/simpleListing/SimpleListing';
import FundraiserCard from '@client/containers/fundraiserCard/FundraiserCard';
import ReactLink from '@client/components/reactLink/ReactLink';
import { selectServerRequestInfo } from '@client/redux/requestState/requestStateReducer';
import { postDonationPayment } from '@client/connectivity/api.donation';
import { selectIndividualFundraiserPageData } from '@client/pages/individualFundraiserPage/duckIndividualFundraiserPage';
import {
  getSocialMediaBoxText,
  isMemorialFundraiser,
} from '@client/shared/utils/fundraiserUtils/fundraiserUtils';
import { trackPurchase, trackFormSent } from '@client/tracking/GTM';
import { createFundraiserDonationUserDataObject } from '@client/tracking/user-data.js';
import { STATUS_APPROVED } from '@client/definitions/constants.js';
import { GIFT_TYPE_FUNDRAISER_DONATION } from '@client/definitions/tracking.js';
import styles from './donateThankYouRoute.scss';

class DonateThankYouRoute extends PureComponent {
  constructor(props) {
    super(props);
  }
  static loadData(dispatch, urlLocation, matchParams) {
    return dispatch(loadDonationPageData(matchParams.donationId));
  }

  componentDidMount() {
    const { location } = this.props;
    const parsedLocationSearch = urlParse(location.search, true);

    DonateThankYouRoute.loadData(
      this.props.dispatch,
      this.props.location,
      this.props.match.params
    ).then(() => {
      const urlQuery = parsedLocationSearch.query;
      if (urlQuery) {
        const { donation } = this.props;

        const paymentData = {
          status: urlQuery.status,
          transactionId: urlQuery.transaction_id,
          paymentRef: urlQuery.payment_ref,
          locale: urlQuery.locale,
          hash: urlQuery.hash,
          errorName: urlQuery.error_name,
        };

        const donatedAmount = getIn(donation, 'donatedAmount');
        const donationId = getIn(donation, 'id');

        if (donationId && donatedAmount > 0) {
          this.handleFormSuccessTracking(donationId, donation);
        }

        const fundraiserId = getIn(donation, 'fundraiser', 'id');

        return postDonationPayment(
          paymentData,
          fundraiserId,
          this.props.match.params.donationId
        );
      }
    });
  }

  handleFormSuccessTracking = (transactionId, donation) => {
    const value = getIn(donation, 'donatedAmount');
    const category = getIn(donation, 'donorType');
    const fundraiserId = getIn(donation, 'fundraiser', 'id');
    const fundraiserSlug = getIn(donation, 'fundraiser', 'slug');

    const items = [
      {
        item_name: GIFT_TYPE_FUNDRAISER_DONATION,
        price: value,
        item_category: category,
        quantity: 1,
      },
    ];

    const params = {
      form_title: GIFT_TYPE_FUNDRAISER_DONATION,
      sender_type: category,
      amount: value,
      fundraiser_id: fundraiserId,
      fundraiser_slug: fundraiserSlug,
    };

    trackFormSent(params);
    trackPurchase(
      transactionId,
      value,
      items,
      createFundraiserDonationUserDataObject(donation)
    );
  };

  getShareUrl = () => {
    const { serverRequestInfo, donation } = this.props;
    const origin = getIn(serverRequestInfo, 'origin');
    const fundraiserSlug = getIn(donation, 'fundraiser', 'slug');
    const fundraiserType = getIn(donation, 'fundraiser', 'fundraiserType');

    return isMemorialFundraiser(fundraiserType)
      ? `${origin}/minnesfonder/${fundraiserSlug}`
      : `${origin}/insamling/${fundraiserSlug}`;
  };

  render() {
    const { donation, translations } = this.props;
    const otherFundraisers = getIn(donation, 'fundraiser', 'otherFundraisers');
    const fundraiserId = getIn(donation, 'fundraiser', 'id');
    const socialMediaText = getSocialMediaBoxText(
      translations,
      getIn(donation, 'fundraiser')
    );

    return (
      <div className={`${styles.donateThankYouPage}`}>
        <div className={`${styleHelper.contentContainer}`}>
          <div className={styles.descriptionSharingColumn}>
            <div
              className={`${styles.leftColumn} ${styleHelper.layoutMobileAndTabletSidePadding}`}
            >
              <h2 className={styleHelper.titleMdPrimary}>
                Tack {getIn(donation, 'donorFirstName')}{' '}
                {getIn(donation, 'donorLastName')} för din gåva på{' '}
                {getIn(donation, 'donatedAmount')} kronor till forskningen!
              </h2>
              <p>
                Din gåva gör verkligen skillnad. Medan du läser detta pågår
                ungefär 300 olika forskningsprojekt runt om i landet, projekt
                som vi kan finansiera tack vare din och andras gåvor.
              </p>
              <p>
                Forskningen vi stödjer håller högsta vetenskapliga kvalitet. Den
                har räddat 260 000 liv de senaste 40 åren, och den fortsätter
                ständigt att ge människor ett längre och friskare liv.
              </p>
            </div>
            <div className={styles.rightColumn}>
              <div className={styles.sharingBox}>
                <h3>Dela insamlingen</h3>
                <p>{socialMediaText}</p>
                <SocialMediaSharing
                  fundraiserId={fundraiserId}
                  url={this.getShareUrl()}
                  hashtag="hjärtlungfonden"
                  via="hjartlungfonden"
                  title={getIn(donation, 'fundraiser', 'title')}
                />
              </div>
            </div>
          </div>
          {otherFundraisers && otherFundraisers.size > 0 && (
            <>
              <h3
                className={`${styleHelper.titleMdPrimary} ${styles.moreFundraisersTitle}`}
              >
                Fler insamlingar
              </h3>
              <div className={styleHelper.alignmentContainer}>
                <SimpleListing
                  className={styleHelper.cardListGrid}
                  list={otherFundraisers}
                  ListItemComponent={FundraiserCard}
                  listItemProps={{
                    itemObjName: 'fundraiser',
                  }}
                />
              </div>
            </>
          )}
          <ReactLink
            className={`${styleHelper.hlfLink} ${styles.seeMoreFundraiserLink}`}
            to={'/'}
          >
            Tillbaka till startsidan
          </ReactLink>
        </div>
        <MoreFromHlf />
      </div>
    );
  }
}

DonateThankYouRoute.propTypes = {
  dispatch: PropTypes.func,
  location: PropTypes.object,
  match: PropTypes.object,
  donation: ImmutablePropTypes.map,
  serverRequestInfo: ImmutablePropTypes.map,
  translations: ImmutablePropTypes.map,
};

function mapStateToProps(state) {
  return {
    donation: selectDonatePageDonation(state),
    serverRequestInfo: selectServerRequestInfo(state),
    translations: selectIndividualFundraiserPageData(state),
  };
}

export default connect(mapStateToProps)(DonateThankYouRoute);
